import { render, staticRenderFns } from "./crop-image-preview.vue?vue&type=template&id=36edfe1d&scoped=true"
import script from "./crop-image-preview.vue?vue&type=script&lang=ts"
export * from "./crop-image-preview.vue?vue&type=script&lang=ts"
import style0 from "./crop-image-preview.vue?vue&type=style&index=0&id=36edfe1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edfe1d",
  null
  
)

export default component.exports